import isEqual from 'lodash/isEqual'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import { PAPER_ELEMENT_TYPE } from '../../../shared/constants/drawable-types'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Select, Workspace } from '../../lib/toolBoxes/2D'
import {
    getDrawableSelectionState,
    updateDrawableSelection,
} from '../../lib/utils/functionality-bindings/addSelectFunctionalityToDrawable'
import {
    addEstimatedOptionOverlayChunkId,
    addOverlayChunkId,
    removeEstimatedOptionOverlayChunkId,
    removeOverlayChunkId,
    resetEstimatedOptionOverlayChunkId,
    setEstimatedOptionOverlayChunkId,
    setKeyboardMultiSelectedItems,
    setOverlayChunkId,
    updateOverlayChunkId,
} from '../../slices/2D'
import { availableMode, enableIMUP, selectActiveMode } from '../../slices/common'
import { sceneRendered } from '../../slices/loading'
import {
    updateConflictResolutionFlag,
    updateOverlaidChunkLockedFlag,
    updateReviewingConflictsFlag,
} from '../../slices/masterSetPlan'
import { gotProjectAction, selectProjectWithId } from '../../slices/project'
import { VIEW_MODE } from '../../types'

export function* watchForDrawableSelection() {
    let previousSelection: ReturnType<typeof getDrawableSelectionState> | null = null

    yield takeEvery(
        [
            enableIMUP.type,
            selectProjectWithId.type,
            availableMode.type,
            gotProjectAction.type,
            sceneRendered.type,
            updateConflictResolutionFlag.type,
            updateOverlaidChunkLockedFlag.type,
            updateReviewingConflictsFlag.type,
            setOverlayChunkId.type,
            addOverlayChunkId.type,
            removeOverlayChunkId.type,
            updateOverlayChunkId.type,
            setEstimatedOptionOverlayChunkId.type,
            addEstimatedOptionOverlayChunkId.type,
            removeEstimatedOptionOverlayChunkId.type,
            resetEstimatedOptionOverlayChunkId.type,
        ],
        function* syncDrawableSelection() {
            const activeMode: VIEW_MODE | null = yield select(selectActiveMode)

            if (activeMode !== VIEW_MODE.Markup2D) {
                previousSelection = null

                return
            }

            const selection: ReturnType<typeof getDrawableSelectionState> = yield select(getDrawableSelectionState)

            if (isEqual(selection, previousSelection)) return

            const manager: PaperManager | null = yield call(managers.get2DManager)

            if (!manager) return

            const shouldClearSelection =
                (selection.isGroupActivationBlocked && !previousSelection?.isGroupActivationBlocked) ||
                (selection.areBaseMaterialsReadOnly && !previousSelection?.areBaseMaterialsReadOnly)

            previousSelection = selection
            const [selectTool, workspaceTool]: [Select, Workspace] = yield call(manager.getTools, [
                Select.NAME,
                Workspace.NAME,
            ])

            if (shouldClearSelection) {
                yield call(selectTool.exitSelectMode)
                yield call(selectTool.clearAllMultiSelections, true)
                yield put(setKeyboardMultiSelectedItems(null))
                workspaceTool.getPaperScope().project.view.onFrame = null
                yield call(workspaceTool.setTooltip, { title: '', visible: false, color: '#000000' })
            }

            const items: paper.Item[] = yield call(
                workspaceTool.getItemsWithCriteria,
                'data',
                (data) => data.type === PAPER_ELEMENT_TYPE.DRAWABLE
            )

            items.forEach((item) => updateDrawableSelection(item, selection))
        }
    )
}
